import { render, staticRenderFns } from "./AiTriageModelConfigModal.vue?vue&type=template&id=0a81825c&scoped=true&"
import script from "./AiTriageModelConfigModal.vue?vue&type=script&lang=js&"
export * from "./AiTriageModelConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./AiTriageModelConfigModal.vue?vue&type=style&index=0&id=0a81825c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81825c",
  null
  
)

export default component.exports